import { createSlice } from "@reduxjs/toolkit";

const initialState: null | {
    refuseReasons: any;
} = {
    refuseReasons: null,
};

const settingsSlice = createSlice({
    name: "settings",
    initialState,
    reducers: {
        setSettings(state, action) {
            return {
                ...state,
                ...action.payload,
            };
        },
        updateRefuseReason(state, action) {
            const { id, is_active } = action.payload;
            const reason = state.refuseReasons?.find((entry: { id: number }) => entry.id === id);
            if (reason) {
                reason.is_active = is_active;
            }
        },
        clearSettings() {
            return initialState;
        },
    },
});

export const { setSettings, updateRefuseReason, clearSettings } = settingsSlice.actions;

export default settingsSlice.reducer;
